/**
 * 拼接图片 URL：若 cover 本身是 http/https 地址则直接返回，
 * 否则拼接 process.env.VUE_APP_BASE_API 前缀。
 *
 * @param {string} cover 图片地址（相对路径或绝对 URL）
 * @param {string} [baseApi] 可选的 API base，默认取 process.env.VUE_APP_BASE_API
 * @returns {string} 完整可访问的图片 URL
 */
export function getImageURL(cover, baseApi) {
  if (!cover) {
    return cover || ''
  }
  const base = baseApi || process.env.VUE_APP_BASE_API || ''
  if (/^(https?)/.test(cover)) {
    return cover
  }
  return base + cover
}
